import http from "./http-common";

class QuestDataService {
  getQuestList() {
    return http.get("/quest");
  }
  getQuestListBySeasonId(seasonId) {
    return http.get("/quest?seasonId=" + seasonId);
  }
  getQuestListById(data) {
    return http.get("/quest?userId=" + data);
  }

  getCurrentQuestList() {
    return http.get("/quest/current");
  }

  postQuestDecision(data) {
    return http.put("/quest/decision", data);
  }

  assignQuestToUser(data) {
    return http.post("/quest", data);
  }
}

export default new QuestDataService();
